import { EMPTY_LIST, EMPTY_OBJECT } from './common'
import {
  ROUTE_PATH_LIST,
  ROUTE_PATH_LIST_RENTAL_PORTAL,
  ROUTE_UI_SECTION_NAME,
  ROUTE_UI_SECTION_NAME_RENTAL_PORTAL,
} from './route'

import BuildingIcon from '../icons/building.svg'
import BuildingGroupsIcon from '../icons/buildings-group.svg'
import ChatIcon from '../icons/chats.svg'
import DocFlowIcon from '../icons/doc-splitting.svg'
import EmailIcon from '../icons/email.svg'
import ConnectedServiceRequestIcon from '../icons/external-request.svg'
import FaqIcon from '../icons/faq.svg'
import FlatIcon from '../icons/flat.svg'
import DocumentIcon from '../icons/folder.svg'
import HomeIcon from '../icons/home-light.svg'
import AboutIcon from '../icons/info.svg'
import OrderIcon from '../icons/orders.svg'
import PostIcon from '../icons/post.svg'
import ProviderIcon from '../icons/providers.svg'
import RentalPortalIcon from '../icons/rental-portal.svg'
import ServiceRequestIcon from '../icons/service-request.svg'
import TaskIcon from '../icons/task.svg'
import UserIcon from '../icons/user.svg'

export const MENU_POST_ITEM = {
  icon: HomeIcon,
  title: 'PostList.PageTitleKey',
  to: '/',
  uiSectionName: ROUTE_UI_SECTION_NAME.newsboard,
}

// The root keeps the newsboard's counter alias, and the dashboard has no webapp page.
export const MENU_DASHBOARD_ITEM = {
  alwaysAvailable: true,
  icon: HomeIcon,
  title: 'DashboardBirdview.PageTitleKey',
  to: '/',
  uiSectionName: ROUTE_UI_SECTION_NAME.dashboard,
  withoutCounter: true,
}

export const MENU_NEWSBOARD_ITEM = {
  ...MENU_POST_ITEM,
  icon: PostIcon,
  to: ROUTE_PATH_LIST.newsboard,
  webappTo: '/',
}

export const MENU_EMAIL_ITEM = {
  icon: EmailIcon,
  title: 'EmailTable.PageTitleKey',
  to: ROUTE_PATH_LIST.mails,
  uiSectionName: ROUTE_UI_SECTION_NAME.mails,
}

export const MENU_SERVICE_REQUEST_ITEM = {
  icon: ServiceRequestIcon,
  title: 'RequestTable.PageTitleKey',
  to: ROUTE_PATH_LIST.serviceRequests,
  uiSectionName: ROUTE_UI_SECTION_NAME.serviceRequests,
}

export const MENU_IDWELL_TO_IDWELL_ITEM = {
  icon: ConnectedServiceRequestIcon,
  title: 'IdwellToIdwellTable.PageTitleKey',
  to: ROUTE_PATH_LIST.idwellToIdwell,
  uiSectionName: ROUTE_UI_SECTION_NAME.idwellToIdwell,
}

export const MENU_TASK_ITEM = {
  icon: TaskIcon,
  title: 'TaskTable.PageTitleKey',
  to: ROUTE_PATH_LIST.tasks,
  uiSectionName: ROUTE_UI_SECTION_NAME.activities,
}

export const MENU_CHAT_ITEM = {
  icon: ChatIcon,
  title: 'ChatTable.PageTitleKey',
  to: ROUTE_PATH_LIST.chats,
  uiSectionName: ROUTE_UI_SECTION_NAME.chats,
}

export const MENU_DOCUMENT_ITEM = {
  icon: DocumentIcon,
  title: 'DocumentTable.PageTitleKey',
  to: ROUTE_PATH_LIST.documents,
  uiSectionName: ROUTE_UI_SECTION_NAME.documents,
}

export const MENU_DOCUMENT_ITEM_DWELLER = {
  ...MENU_DOCUMENT_ITEM,
  to: ROUTE_PATH_LIST.documentsDweller,
  uiSectionName: ROUTE_UI_SECTION_NAME.documentsDweller,
}

export const MENU_DOCUMENT_STAPLING_ITEM = {
  icon: DocFlowIcon,
  title: 'DocumentStaplingTable.PageTitleKey',
  to: ROUTE_PATH_LIST.docFlows,
  uiSectionName: ROUTE_UI_SECTION_NAME.docFlows,
}

export const MENU_INHABITANT_ITEM = {
  icon: UserIcon,
  title: 'InhabitantTable.PageTitleKey',
  to: ROUTE_PATH_LIST.inhabitants,
  uiSectionName: ROUTE_UI_SECTION_NAME.inhabitants,
}

export const MENU_FLAT_ITEM = {
  icon: FlatIcon,
  title: 'FlatTable.PageTitleKey',
  to: ROUTE_PATH_LIST.flats,
  uiSectionName: ROUTE_UI_SECTION_NAME.flats,
}

export const MENU_BUILDING_ITEM = {
  icon: BuildingIcon,
  title: 'BuildingTable.PageTitleKey',
  to: ROUTE_PATH_LIST.buildings,
  uiSectionName: ROUTE_UI_SECTION_NAME.buildings,
}

export const MENU_BUILDING_GROUP_ITEM = {
  icon: BuildingGroupsIcon,
  title: 'BuildingGroupTable.PageTitleKey',
  to: ROUTE_PATH_LIST.buildingsGroup,
  uiSectionName: ROUTE_UI_SECTION_NAME.buildingGroups,
}

export const MENU_FAQ_ITEM = {
  icon: FaqIcon,
  title: 'FAQ.PageTitleKey',
  to: ROUTE_PATH_LIST.faq,
  uiSectionName: ROUTE_UI_SECTION_NAME.faq,
}

export const MENU_ALL_PROVIDERS_ITEM = {
  icon: ProviderIcon,
  title: 'AllProvidersTable.PageTitleKey',
  to: 'marketplace/all-providers',
}

export const MENU_PROVIDERS_ITEM = {
  icon: ProviderIcon,
  title: 'Providers.PageTitleKey',
  to: ROUTE_PATH_LIST.providers,
  uiSectionName: ROUTE_UI_SECTION_NAME.providers,
}

export const MENU_RENTAL_PORTAL_ITEM = {
  alwaysAvailable: true,
  icon: RentalPortalIcon,
  title: 'RentalPortal.PageTitleKey',
  to: ROUTE_PATH_LIST_RENTAL_PORTAL.root,
  uiSectionName: ROUTE_UI_SECTION_NAME_RENTAL_PORTAL.root,
  withNestedRoutes: true,
}

export const MENU_MARKETPLACE_ITEM = {
  icon: OrderIcon,
  title: 'Marketplace.PageTitleKey',
  to: 'marketplace',
}

export const MENU_ABOUT_ITEM = {
  icon: AboutIcon,
  title: 'About.PageTitleKey',
  to: ROUTE_PATH_LIST.aboutUs,
  uiSectionName: ROUTE_UI_SECTION_NAME.aboutUs,
  webappTo: 'uk',
}

export const MENU_ITEM_COUNTER_MAX_VALUE = 99

export const MIN_SUB_MENU_ITEMS_SIZE = 2

export const SUB_MENU_INITIAL_STATE = {
  accounts: EMPTY_OBJECT,
  idwellToIdwellCompanies: EMPTY_LIST,
  items: EMPTY_LIST,
}

export const MENU_COUNTER_ALIASES = {
  [MENU_CHAT_ITEM.to]: 'unread_chats',
  [MENU_EMAIL_ITEM.to]: 'unread_emails',
  [MENU_INHABITANT_ITEM.to]: 'dwellers_landlords',
  [MENU_NEWSBOARD_ITEM.to]: 'unread_posts',
  [MENU_POST_ITEM.to]: 'unread_posts',
  [MENU_SERVICE_REQUEST_ITEM.to]: 'unviewed_requests',
  friends: 'friend_invites',
}
